import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const ResetPassword = () => {
	const [searchParams] = useSearchParams()
	const token = searchParams.get('token')
	const userId = searchParams.get('id')

	const [newPassword, setNewPassword] = useState("")
	const [confirmPassword, setConfirmPassword] = useState("")
	const [isLoading, setIsLoading] = useState(false)
	const [success, setSuccess] = useState(false)
	const [error, setError] = useState("")

	if (!token || !userId) {
		return (
			<>
				<div className="login">
					<div className="login__forms">
						<div className="col-md-6 col-12">
							<div className="form__wrap">
								<h1 className="text-align--center">Invalid Reset Link</h1>
								<p className="text-align--center">This password reset link is invalid or has expired.</p>
								<Link className="form__link" to="/login">Back to login</Link>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setError("")

		if (newPassword.length < 8) {
			setError("Password must be at least 8 characters long.")
			return
		}

		if (newPassword !== confirmPassword) {
			setError("Passwords do not match.")
			return
		}

		setIsLoading(true)
		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_WEB_URL}reset-password`,
				{ userId, token, newPassword },
				{ withCredentials: true }
			)
			if (data.success) {
				setSuccess(true)
			} else {
				setError(data.message || "Something went wrong.")
			}
		} catch (err) {
			setError("Something went wrong. Please try again later.")
		} finally {
			setIsLoading(false)
		}
	}

	if (success) {
		return (
			<>
				<div className="login">
					<div className="login__forms">
						<div className="col-md-6 col-12">
							<div className="form__wrap">
								<h1 className="text-align--center">Password Reset</h1>
								<p className="text-align--center">Your password has been reset successfully.</p>
								<Link className="form__link" to="/login">Log in with your new password</Link>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}

	return (
		<>
			<div className="login">
				<div className="login__forms">
					<div className="col-md-6 col-12">
						<div className="form__wrap">
							<h1 className="text-align--center">Reset Password</h1>
							<form onSubmit={handleSubmit}>
								<div className="form__group">
									<label htmlFor="newPassword" className="form__label">New Password</label>
									<input
										className="form__input"
										type="password"
										name="newPassword"
										value={newPassword}
										placeholder="New password (min 8 characters)"
										onChange={(e) => setNewPassword(e.target.value)}
										required
									/>
								</div>
								<div className="form__group">
									<label htmlFor="confirmPassword" className="form__label">Confirm Password</label>
									<input
										className="form__input"
										type="password"
										name="confirmPassword"
										value={confirmPassword}
										placeholder="Confirm new password"
										onChange={(e) => setConfirmPassword(e.target.value)}
										required
									/>
								</div>
								{error && <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>}
								<button className="form__button" type="submit" disabled={isLoading}>
									{isLoading ? "Resetting..." : "Reset Password"}
								</button>
							</form>
							<Link className="form__link" to="/login">Back to login</Link>
						</div>
					</div>
				</div>
			</div>
			<ToastContainer />
		</>
	);
};

export default ResetPassword
